import * as React from "react";
import { H2, Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { useShippingStateConfig } from "../../../../../hooks/LoginExpressCheckout/hooks/useShippingStateConfig.js";
import { ShippingMethodsListContainer } from "../../../../../../StepShipping/modules/ShippingMethods/containers/StepShipping/modules/ShippingMethods/containers/ShippingMethodsListContainer.js";
import { ShippingMethod } from "../../../../../../models/step-shipping/models/step-shipping/shipping-methods.js";
import { SelectedShippingMethodContainer } from "../../../../../../StepShipping/modules/ShippingMethods/containers/StepShipping/modules/ShippingMethods/containers/SelectedShippingMethodContainer.js";
const ShippingMethodsContainer = ({ shippingMethodsAsides }) => {
  const { getLabel } = useIntl();
  const shippingConfig = useShippingStateConfig();
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(H2, { variant: "heading-small" }, getLabel("checkout.instant.shipping.heading")), shippingConfig.shippingMethodList ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ShippingMethodsListContainer,
    {
      asides: shippingMethodsAsides,
      selectedShippingMethod: shippingConfig?.selectedShippingMethod,
      shippingMethodList: shippingConfig.shippingMethodList,
      isLoading: shippingConfig.shippingOptionsLoading,
      error: shippingConfig.shippingOptionsError,
      handleOnShippingMethodSelected: shippingConfig.handleShippingOptionSelection
    }
  ), shippingConfig.selectedShippingMethod?.method == ShippingMethod.NearestPickup && /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, getLabel("checkout.summary.shipment.nearestPickup.message")), /* @__PURE__ */ React.createElement(
    SelectedShippingMethodContainer,
    {
      selectedShippingMethod: shippingConfig.selectedShippingMethod?.method,
      onStoreSelect: shippingConfig.onStoreSelect,
      selectedStore: shippingConfig.selectedStore,
      onPickupPointSelect: shippingConfig.onPickupPointSelect,
      selectedPickupPoint: shippingConfig.selectedPickupPoint,
      onShippingModalClose: shippingConfig.onShippingModalClose
    }
  )) : /* @__PURE__ */ React.createElement(
    Alert,
    {
      className: "alert-m-default checkout-section__alert",
      variant: "warning",
      title: getLabel("checkout.errors.general.shipping.title")
    },
    getLabel("checkout.errors.general.shipping.message")
  ));
};
export {
  ShippingMethodsContainer
};
//# sourceMappingURL=ShippingMethodsContainer.js.map
